var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCruisesMsk = function SvgCruisesMsk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0996 828.797C132.8 828.797 132.8 903.397 207.5 903.397C282.2 903.397 282.2 828.797 356.9 828.797C431.6 828.797 431.6 903.397 506.3 903.397C581 903.397 581 828.797 655.7 828.797C730.4 828.797 730.4 903.397 805.1 903.397C879.8 903.397 879.8 828.797 954.5 828.797",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.2 763.1L156.6 622C149.4 596.8 164 570.6 189.3 563.6L496.9 478.6C505.1 476.3 513.8 476.3 522 478.6L830.3 563.8C855.3 570.7 870 596.4 863.2 621.4L824.9 763.1",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M780.5 550.097V440.997C780.5 423.197 767.7 407.997 750.1 404.997L730.3 401.597L620.2 382.797C547 370.297 471.6 370.297 398.4 382.797L288.3 401.597L268.5 404.997C251 407.997 238.1 423.197 238.1 440.997V550.097",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M730.299 453.9L620.299 435C547.099 422.5 471.699 422.5 398.499 435L288.399 453.8",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.399 401.598V361.998C288.399 344.198 301.199 328.998 318.799 325.998L418.999 308.798C478.599 298.598 540.099 298.598 599.699 308.798L699.999 325.998C717.499 328.998 730.399 344.198 730.399 361.998V401.598",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M509.399 475.195V689.895",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M432.699 306.697V203.197C432.699 176.997 453.899 155.797 480.099 155.797H538.699C564.899 155.797 586.099 176.997 586.099 203.197V306.697",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M574.1 576.297L675.2 603.897",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M445.499 576.297L344.399 603.897",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCruisesMsk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/cruises-msk.svg";